import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { urlReplacer } from "../../../utils";
import { ISchoolLevelWithAcademicBackEndModel } from "../types";

export default function () {
  const { request } = useApi();
  return {
    create: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_ACADEMIC_SECONDARY,
        });
      },
      [request],
    ),

    fetchAll: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: ApiRoutes.ACADEMICS_SECONDARY + stringify(filter),
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_ACADEMIC_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deleteOne: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_ACADEMIC_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    activate: useCallback(
      async (id) => {
        return request({
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.ACTIVATE_ACADEMIC_SECONDARY, { id })}`,
        });
      },
      [request],
    ),

    deactivate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: `${urlReplacer(ApiRoutes.DEACTIVATE_ACADEMIC_SECONDARY, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchAppCount: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: `${
            ApiRoutes.GET_APPLICATION_COUNT_FOR_DEACTIVATION_SECONDARY +
            stringify(filter)
          }`,
        });
      },
      [request],
    ),

    update: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "PUT",
          url: ApiRoutes.UPDATE_ACADEMIC_SECONDARY,
        });
      },
      [request],
    ),
    fetchLevelsWithAcademic: useCallback(
      async (id): Promise<{ data: ISchoolLevelWithAcademicBackEndModel[] }> => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.SCHOOL_LEVELS_WITH_ACADEMIC, { id })}`,
        });
      },
      [request],
    ),
  };
}
